export const en = {
    emptyMessage: 'Enter value',
    gteCpmBannerMessage: 'The bid must not exceed {maxValue}',
    gteCpmBannerMessageWithCurrency: 'The bid must not exceed {maxValue} {currency}',
    gteMessage: 'CPC exceeds the maximum allowed value of {maxValue}',
    gteMessageWithCurrency: 'CPC exceeds the maximum allowed value of {maxValue} {currency} ',
    lteCpmBannerMessage: 'The bid must be at least {minValue}',
    lteCpmBannerMessageWithCurrency: 'The bid must be at least {minValue} {currency}',
    lteMessage: 'CPC is below the minimum possible value of {minValue}',
    lteMessageWithCurrency: 'CPC is below the minimum possible value of {minValue} {currency}',
    nanCpmBannerMessage: 'The bid must be a number',
    nanMessage: 'CPC must be a number'
};
